import AMapLoader from "@amap/amap-jsapi-loader";

// eslint-disable-next-line no-unused-vars
var map;

//获取坐标转成地址信息
export function getAddress(gps) {
    // console.log(this.map,this.map.Geocoder())

    return new Promise((resolve, reject) => {
        window._AMapSecurityConfig = {
            securityJsCode: 'df19512ee4a4e0d5262286b5a11ed3b4'
        }
        AMapLoader.load({
            key: "7b29f9d3b69426a2365449b4247b3202", // 申请好的Web端开发者Key，首次调用 load 时必填
            version: "2.0", // 指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
            plugins: ["Geocoder"], // 需要使用的的插件列表，如比例尺'AMap.Scale'等
        })
            .then((AMap) => {
                // AMap.convertFrom(gps, 'gps', function (status, result) {
                //     if (result.info === 'ok') {
                //         var lnglats = result.locations; // Array.<LngLat>
                AMap.plugin("AMap.Geocoder", function () {
                    console.log("123465111==", gps);
                    var geocoder = new AMap.Geocoder();
                    geocoder.getAddress(gps, function (status, result) {
                        console.log(status, result);
                        if (status === "complete" && result.info === "OK") {
                            // result为对应的地理位置详细信息
                            console.log(result.regeocodes);
                            let str = '';
                            if (!Array.isArray(result.regeocodes)) {
                                str = result.regeocode.formattedAddress
                            } else {
                                str = result.regeocodes[0].formattedAddress
                            }
                            resolve(str)
                        }
                    });
                });
                //     }
                // });

            })
            .catch((e) => {
                console.log(e);
                reject(e)
            });



    })
}

export function convertToLoaction(gps) {
    return new Promise((resolve, reject) => {
        map.convertFrom(gps, 'gps', function (status, result) {
            if (result.info === 'ok') {
                var lnglats = result.locations; // Array.<LngLat>
                resolve(lnglats)
            }
        })
    })
}

//初始化地图
export function initMap() {
    window._AMapSecurityConfig = {
        securityJsCode: 'df19512ee4a4e0d5262286b5a11ed3b4'
    }
    AMapLoader.load({
        key: "7b29f9d3b69426a2365449b4247b3202", // 申请好的Web端开发者Key，首次调用 load 时必填
        version: "2.0", // 指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
        plugins: ["AMap.Geolocation"], // 需要使用的的插件列表，如比例尺'AMap.Scale'等
    })
        .then((AMap) => {
            map = AMap;
        })
        .catch((e) => {
            console.log(e);
        });
}